import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { AccountService } from './account.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(
    private _accountService: AccountService,
    private _router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    const promise = new Promise<boolean>(resolve => {
      this._accountService.isAuthenticated().then(isAuthenticated => {
        if (!isAuthenticated) {
          this._router.navigate(['']);
          resolve(false);
        }

        const isOnlyPremium = next.data.isOnlyPremium;

        if (isOnlyPremium) {
          this._accountService.isPremium().then(isPremium => {
            if (!isPremium) {
              this._router.navigate(['main', 'settings', 'tariff']);
              resolve(false);
            }
          });
        }

        resolve(true);
      });
    });

    return promise;
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.canActivate(childRoute, state);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth.guard.ts